var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{staticClass:"task-gl",attrs:{"to":{
      path:'/faq_list',
      query:{
          cid:this.cid,
          cpid:this.pid
      }
  }}},[_c('img',{attrs:{"src":require("../../assets/hxz.png")}}),_vm._v("\n      快速查看任务攻略\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }